@if (items.length > 0) {
  <div class="annotation-color-legend mt-3" data-testid="annotation-color-legend-view">
    <div class="fw-bold mb-2" style="color: #719eb6">Annotation Colors</div>
    @for (section of groupedItems(); track section.group) {
      <div class="annotation-color-legend-group mb-2">
        <div class="annotation-color-legend-group-title">{{ section.title }}</div>
        <div class="d-flex flex-wrap align-items-center">
          @for (item of section.items; track $index) {
            <div class="annotation-color-legend-item d-flex align-items-center me-4 mb-2">
              <span
                class="annotation-color-legend-swatch"
                [style.background-color]="item.color"
              ></span>
              <span style="color: #4a6f82; font-weight: 600">{{ displayLabel(item) }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
